import { css } from "@emotion/react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { Badge } from "../../ui/badge";

export type ProductBrowserGridItemTagsProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserGridItemTags: React.FC<
	ProductBrowserGridItemTagsProps
> = (props) => {
	const product = props.product;
	const translate = useTranslate();

	return (
		<>
			{product.Tags && (
				<div className="field">
					<div className="caption">{translate("Tags")}:</div>
					<div className="value">
						{product.Tags?.split(",").map((tag) => (
							<span key={product.Id + tag}>
								{tag && (
									<Badge variant="outline" css={css`margin: .25em;`}>
										{tag}
									</Badge>
								)}
							</span>
						))}
					</div>
				</div>
			)}
		</>
	);
};
